import React, { useEffect } from "react";
import { useTheme } from "../context/ThemeContext";

function Contact() {
  const { theme } = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container mx-auto my-8 px-4">
      <h2
        className={`text-5xl md:text-6xl font-light mb-6 ${theme.text} font-handwriting`}
      >
        Kontakt
      </h2>

      <div className="grid md:grid-cols-2 gap-8">
        <div className={`${theme.box} p-8 rounded-lg shadow-lg`}>
          <h3 className="text-2xl font-semibold mb-6 text-slate-800">
            Walk & Talk Beratung
          </h3>
          <div className="space-y-4 text-lg text-slate-700">
            <p>
              Die Beratungsgespräche finden als Spaziergang in der Natur im Raum
              Wittlich statt. Den genauen Treffpunkt vereinbaren wir
              individuell.
            </p>
            <p>
              Bei sehr schlechtem Wetter können wir alternativ auf eine
              telefonische Beratung ausweichen.
            </p>
          </div>
        </div>

        <div className={`${theme.box} p-8 rounded-lg shadow-lg`}>
          <h3 className="text-2xl font-semibold mb-6 text-slate-800">
            Online-Beratung
          </h3>
          <div className="space-y-4 text-lg text-slate-700">
            <p>
              Alternativ biete ich auch Online-Beratung per Videochat an. Dies
              ermöglicht Ihnen eine ortsunabhängige Beratung von zu Hause aus.
            </p>
            <p>
              Nach Terminvereinbarung erhalten Sie einen Link für unsere
              Video-Sitzung.
            </p>
          </div>
        </div>

        <div
          className={`md:col-span-2 bg-gradient-to-br ${theme.gradient} p-8 rounded-lg shadow-lg text-white max-w-3xl`}
        >
          <h3 className="text-2xl font-bold mb-6">Kontaktdaten</h3>
          <div className="space-y-4 text-lg mb-8">
            <p>Lisa Fuchsen</p>
            <p>Sozialpädagogin & Systemische Beraterin (SG)</p>
            <p>E-Mail: stepintochange.withlisa@gmail.com</p>
          </div>
          <div className="flex gap-4">
            <a
              href="tel:+491762029374"
              className="inline-block bg-white text-slate-800 px-6 py-3 rounded-lg hover:bg-slate-100 transition-colors shadow-md"
            >
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                Anrufen
              </div>
            </a>
            <a
              href="mailto:stepintochange.withlisa@gmail.com"
              className="inline-block bg-white text-slate-800 px-6 py-3 rounded-lg hover:bg-slate-100 transition-colors shadow-md"
            >
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                E-Mail schreiben
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
